import {
  PULSE_BLOCK_TYPE,
  type PulseTableData,
  type SaveToPulseInput,
} from '../types';

type CapturedTable = PulseTableData & { name?: string };

const TABLE_PRESENTATION_SAMPLE_SIZE = 10;

export const getTableSaveToPulseInput = (
  table: CapturedTable,
): Pick<SaveToPulseInput, 'blockType' | 'suggestedName' | 'tableData'> => ({
  suggestedName: table.name || 'Table',
  blockType: PULSE_BLOCK_TYPE.TABLE,
  tableData: {
    columns: table.columns,
    rows: table.rows.slice(0, TABLE_PRESENTATION_SAMPLE_SIZE),
  },
});
